const init = () => {

    const wrapperEl = document.querySelector('.partial-add-to-any')
    if (wrapperEl === null) return

    const buttonEl = wrapperEl.querySelector('.add-to-any-button')
    const contentEl = wrapperEl.querySelector('.add-to-any-content')

    const toggleContent = (event) => {
        if (contentEl.classList.contains('is-open')) {
            contentEl.classList.remove('is-open')
        } else {
            contentEl.classList.add('is-open')
        }
    }

    const closeContent = (event) => {
        contentEl.classList.remove('is-open')
    }

    buttonEl.addEventListener('click', toggleContent)
    // wrapperEl.addEventListener('mouseleave', closeContent)

}

document.addEventListener('DOMContentLoaded', (event) => {
    init()
})
